import React from 'react';

const icons = {
  home: (isActive: boolean) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 21"
      width="20"
      height="21"
      fill="none"
    >
      <path
        fill={isActive ? '#FF4F08' : '#8D94AD'}
        fillRule="evenodd"
        d="m10.432.182 9.25 8.867a1.043 1.043 0 0 1-.724 1.793H17.5v7.5c0 .92-.746 1.666-1.667 1.666h-3.85v-5.011a1 1 0 0 0-1-1H9.016a1 1 0 0 0-1 1v5.01h-3.85c-.92 0-1.666-.745-1.666-1.666v-7.5H1.042a1.043 1.043 0 0 1-.734-1.783L9.568.182a.625.625 0 0 1 .864 0Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  favorites: (isActive: boolean) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 21"
      width="24"
      height="21"
      fill="none"
    >
      <path
        fill={isActive ? '#FF4F08' : '#8D94AD'}
        d="M20.201.826A6.528 6.528 0 0 0 17.04.012c-2.026 0-3.84.923-5.037 2.371A6.542 6.542 0 0 0 3.798.826 6.552 6.552 0 0 0 .414 6.563c0 .707.115 1.385.323 2.02 1.124 5.05 11.265 11.422 11.265 11.422s10.134-6.371 11.26-11.423a6.465 6.465 0 0 0 .324-2.02A6.555 6.555 0 0 0 20.2.827Z"
      />
    </svg>
  ),
  add: () => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 46 45"
      width="46"
      height="45"
      fill="none"
    >
      <circle cx="23" cy="22.5" r="22.5" fill="url(#a)" />
      <path
        fill="#fff"
        stroke="#fff"
        strokeWidth="1.171"
        d="M33.119 21.286h-9.31V12.38a.81.81 0 1 0-1.619 0v8.905h-9.31a.81.81 0 1 0 0 1.619h9.31v9.714a.81.81 0 1 0 1.62 0v-9.714h9.309a.81.81 0 1 0 0-1.62Z"
      />
      <defs>
        <linearGradient
          id="a"
          x1="-22"
          x2="23"
          y1="22.5"
          y2="67.5"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#FE5722" />
          <stop offset=".529" stopColor="#FE5631" />
          <stop offset=".833" stopColor="#FE5449" />
          <stop offset="1" stopColor="#FE6168" />
        </linearGradient>
      </defs>
    </svg>
  ),
  messages: (isActive: boolean) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width="20"
      height="20"
      fill="none"
    >
      <path
        fill={isActive ? '#FF4F08' : '#8D94AD'}
        fillRule="evenodd"
        d="M20 10c0 5.523-4.477 10-10 10a9.953 9.953 0 0 1-5.192-1.452L.407 19.646l1.087-4.385A9.953 9.953 0 0 1 0 10C0 4.477 4.477 0 10 0s10 4.477 10 10ZM5.5 11.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Zm6-1.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0Zm3 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3Z"
        clipRule="evenodd"
      />
    </svg>
  ),
  cabinet: (isActive: boolean) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
      width="20"
      height="20"
      fill="none"
    >
      <path
        fill={isActive ? '#FF4F08' : '#8D94AD'}
        fillRule="evenodd"
        d="M10 .108c-5.467 0-9.9 4.433-9.9 9.9 0 5.468 4.433 9.9 9.9 9.9 5.468 0 9.9-4.432 9.9-9.9 0-5.467-4.432-9.9-9.9-9.9Zm0 2.96a3.275 3.275 0 1 1 0 6.55 3.275 3.275 0 0 1 0-6.55ZM5.267 15.576a7.265 7.265 0 0 0 4.73 1.745 7.263 7.263 0 0 0 4.733-1.745c.31-.265.489-.652.489-1.06a3.298 3.298 0 0 0-3.313-3.302h-3.81a3.302 3.302 0 0 0-3.319 3.302c0 .407.18.795.49 1.06Z"
        clipRule="evenodd"
      />
    </svg>
  ),
};

export type TabBarIconName = keyof typeof icons;

interface TabBarIconProps {
  name: TabBarIconName;
  isActive?: boolean;
}

export const TabBarIcon: React.FC<TabBarIconProps> = ({
  name,
  isActive = false,
}) => {
  const IconComponent = icons[name];
  return IconComponent ? IconComponent(isActive) : null;
};
